import { render, staticRenderFns } from "./deptAddOrUpdate.vue?vue&type=template&id=746e53f7&scoped=true&"
import script from "./deptAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./deptAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746e53f7",
  null
  
)

export default component.exports